module.exports = __webpack_public_path__ + "img/35.ccdb8885.jpg";